import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_HERONEWS_REQUEST = 'HeroNews/FETCH_HERONEWS_REQUEST'
const FETCH_HERONEWS_SUCCESS = 'HeroNews/FETCH_HERONEWS_SUCCESS'
const FETCH_HERONEWS_FAILURE = 'HeroNews/FETCH_HERONEWS_FAILURE'

const CREATE_HERONEWS_REQUEST = 'HeroNews/CREATE_HERONEWS_REQUEST'
const CREATE_HERONEWS_SUCCESS = 'HeroNews/CREATE_HERONEWS_SUCCESS'
const CREATE_HERONEWS_FAILURE = 'HeroNews/CREATE_HERONEWS_FAILURE'

const UPDATE_HERONEWS_REQUEST = 'HeroNews/UPDATE_HERONEWS_REQUEST'
const UPDATE_HERONEWS_SUCCESS = 'HeroNews/UPDATE_HERONEWS_SUCCESS'
const UPDATE_HERONEWS_FAILURE = 'HeroNews/UPDATE_HERONEWS_FAILURE'

const DELETE_HERONEWS_REQUEST = 'HeroNews/DELETE_HERONEWS_REQUEST'
const DELETE_HERONEWS_SUCCESS = 'HeroNews/DELETE_HERONEWS_SUCCESS'
const DELETE_HERONEWS_FAILURE = 'HeroNews/DELETE_HERONEWS_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  heroNewsList: [],
}

// Default Reducer
const heroNews = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HERONEWS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_HERONEWS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        heroNewsList: action.payload
      }
    case FETCH_HERONEWS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_HERONEWS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_HERONEWS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_HERONEWS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_HERONEWS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_HERONEWS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_HERONEWS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_HERONEWS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_HERONEWS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_HERONEWS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }

    default:
      return state
  }
}

export default heroNews

// Action Creators
export const fetchHeroNewsList = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_HERONEWS_REQUEST
      })

      const response = await API.get(EndPoints.HERONEWS+ `/getAll`)
      dispatch({
        type: FETCH_HERONEWS_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_HERONEWS_FAILURE
      })
    }
  }
}

export const createHeroNews = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_HERONEWS_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.HERONEWS+ `/createHeroNews`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_HERONEWS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_HERONEWS_FAILURE
      })
    }
  }
}

export const updateHeroNews = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_HERONEWS_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.HERONEWS+ `/updateHeroNews`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_HERONEWS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_HERONEWS_FAILURE
      })
    }
  }
}

export const deleteHeroNews = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_HERONEWS_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.HERONEWS + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_HERONEWS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_HERONEWS_FAILURE
      })
    }
  }
}






